import { TweenMax, Power4 } from 'gsap'
import ScrollMagic from 'scrollmagic'
import platform from 'platform'

export default (function() {

  let scenes = [];
  let resizeHandler;

  function init(scrollController) {

    // if (platform.os.family.match(/(ios|android)/i)) {
    //   document.querySelector('html').classList.add('no-parallax')
    //   return;
    // }

    const parallaxImageBlocks = Array.from(document.querySelectorAll('.content-parallax-block'))
    const parallaxImages = parallaxImageBlocks.map((imageBlock) => imageBlock.querySelector('.o-responsive-image__image'))

    if (resizeHandler) {
      window.removeEventListener('optimizedResize', resizeHandler)
    }

    function addScene(block, image) {

      let blockRect = block.getBoundingClientRect()
      let imageRect = image.getBoundingClientRect();
      let movable = (imageRect.height - blockRect.height) * -1

      let parallaxTween = TweenMax.to(image, 1, { css: { y: movable, force3D: true }}, { ease: Power4.easeInOut })

      let scene = new ScrollMagic.Scene({
        triggerElement: block,
        triggerHook: 'onEnter',
        duration: window.innerHeight,
        offset: window.innerHeight * .5
      })
      .setTween(parallaxTween)
      .addTo(scrollController);

      scenes.push(scene)
    }

    resizeHandler = () => {
      // Remove the existing scenes so they can be recreated
      scenes.forEach((scene) => {
        scene.destroy(true)
      })

      const maxImageWidth = 1920
      const maxMaskHeight = 1080
      const maxImageHeight = 1440

      let maxMovable = maxImageHeight - maxMaskHeight;
      maxMovable = (maxMovable * (window.innerWidth / maxImageWidth)) * -1

      // Parallax image blocks
      parallaxImageBlocks.forEach((imageBlock, i) => {
        (function(block, image) {
          if (image.classList.contains('lazyloaded')) {
            addScene(block, image)
          } else {
            image.addEventListener('lazyloaded', function() {
              addScene(block, image)
            })

            window.lazySizes.loader.unveil(image)
          }

        })(parallaxImageBlocks[i], parallaxImages[i]);
      })
    }

    resizeHandler()
  }

  return {
    init
  }

})();
